import { EmptyState, FlexBox } from '@dixa/lib-shared-habla';

export const DashboardError = (): JSX.Element => {
  return (
    <FlexBox
      flexDirection="column"
      height="100%"
      alignItems="center"
      justifyContent="center"
    >
      <EmptyState
        title="Something went wrong"
        description="We're experiencing some issues, try again or reload the page. If this issue persists, please contact support."
        icon="exclamation"
        iconColor="red.500"
        buttonProps={{
          children: 'Try reloading',
          onClick: () => window.location.reload(),
        }}
      />
    </FlexBox>
  );
};
